var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.5001V19.4671C3 21.7771 5.534 23.2361 7.597 22.1151L10.8 20.3731M3 8.50006V5.53306C3 3.22306 5.534 1.76406 7.597 2.88506L20.409 9.85306C20.8893 10.1085 21.291 10.4898 21.5712 10.956C21.8514 11.4223 21.9994 11.9561 21.9994 12.5001C21.9994 13.044 21.8514 13.5778 21.5712 14.0441C21.291 14.5104 20.8893 14.8917 20.409 15.1471L14.003 18.6311",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo);
export default __webpack_public_path__ + "static/media/demo.509257aab28c4aba9f2d9039f3282e94.svg";
export { ForwardRef as ReactComponent };